import { Link } from "react-router-dom";
import { Star, ChatCircleText, ShoppingBagOpen } from "@phosphor-icons/react";
import { Icon } from "@/lib/icons";
import { fmtPrice } from "@/lib/api";

export const AgentAvatar = ({ icon, color = "#2563EB", size = 44 }) => (
  <div
    className="grid shrink-0 place-items-center border"
    style={{ width: size, height: size, borderColor: `${color}55`, background: `${color}14`, color }}
  >
    <Icon name={icon} size={Math.round(size * 0.5)} weight="duotone" />
  </div>
);

export const Rating = ({ agent }) =>
  agent.rating_count ? (
    <span className="inline-flex items-center gap-1 text-xs text-zinc-300">
      <Star size={12} weight="fill" className="text-amber-400" /> {agent.rating_avg.toFixed(1)}
      <span className="text-zinc-600">({agent.rating_count})</span>
    </span>
  ) : (
    <span className="text-[11px] font-semibold uppercase tracking-widest text-cyan-400">Nuevo</span>
  );

export const AgentCard = ({ agent, index = 0, large = false }) => (
  <Link
    to={`/agent/${agent.agent_id}`}
    data-testid={`agent-card-${agent.agent_id}`}
    className={`reveal group relative flex flex-col justify-between bg-[#0b0b0b] p-6 hover:bg-[#121212] ${large ? "min-h-[300px] p-8" : "min-h-[230px]"}`}
    style={{ animationDelay: `${index * 50}ms`, transition: "background-color 200ms ease-out" }}
  >
    <span className="absolute inset-x-0 top-0 h-px scale-x-0 bg-blue-500 group-hover:scale-x-100" style={{ transformOrigin: "left", transition: "transform 300ms ease-out" }} />
    <div>
      <div className="mb-5 flex items-start justify-between gap-3">
        <AgentAvatar icon={agent.icon} color={agent.color} size={large ? 56 : 44} />
        <span className="border border-white/10 px-2 py-1 font-mono text-[10px] uppercase tracking-wider text-zinc-400">{agent.model_label || agent.model}</span>
      </div>
      <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-zinc-500">{agent.category}</p>
      <h3 className={`font-display font-bold tracking-tight text-white ${large ? "text-2xl sm:text-3xl" : "text-lg"}`}>{agent.name}</h3>
      <p className={`mt-2 line-clamp-2 text-zinc-400 ${large ? "text-base" : "text-sm"}`}>{agent.tagline}</p>
    </div>
    <div className="mt-6 flex items-center justify-between border-t border-white/5 pt-4">
      <div className="flex items-center gap-4">
        <Rating agent={agent} />
        <span className="inline-flex items-center gap-1 text-xs text-zinc-500"><ShoppingBagOpen size={13} /> {agent.sales_count || 0}</span>
        <span className="hidden items-center gap-1 text-xs text-zinc-500 sm:inline-flex"><ChatCircleText size={13} /> {agent.message_count || 0}</span>
      </div>
      <span className="font-mono text-sm font-semibold text-white" data-testid={`agent-card-price-${agent.agent_id}`}>{fmtPrice(agent)}</span>
    </div>
  </Link>
);
